export default "__VITE_ASSET__DSonImz6__"